import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteFeldKategorieCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteFeldKategorieCommandService],
  exports: []
})
export class DeleteFeldKategorieCommandServiceModule { }
